import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta, retry } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { prepareCopy } from "immer/dist/internal";
import jwtDecode from "jwt-decode";
import { HomeVo } from "src/vo/homeVo";
import { UserVo } from "src/vo/userVo";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;
const serverTestIp = process.env.REACT_APP_SERVER_SAMPLE_IP;

// 1-1. initial state 객체 생성
const initialState: HomeVo = {
  asVo: [],
};

export const homeAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  // baseQuery: fetchBaseQuery({
  //   baseUrl: serverIp + "/",
  //   prepareHeaders: (headers, { getState }) => {
  //     const ac_token = getCookie("ac_token");
  //     if (ac_token) {
  //       headers.set("Content-Type", "application/json");
  //       headers.set("Accept", "*/*, text/plain");
  //       headers.set("Authorization", `bearer ${ac_token}`);
  //     }
  //     return headers;
  //   },
  // }),
  // pollingInterval - 쿼리가 밀리초 단위로 지정된 제공된 간격으로 자동으로 다시 가져올 수 있도록 합니다. 기본값은 0 (꺼짐)
  //selectFromResult - 반환된 하위 집합에 대해 렌더링 최적화된 결과의 하위 집합을 얻기 위해 후크의 반환된 값을 변경할 수 있습니다.
  //refetchOnMountOrArgChange - 쿼리가 마운트 시 항상 다시 가져오도록 합니다( true제공된 경우).
  // 동일한 캐시에 대한 마지막 쿼리 이후 충분한 시간(초 단위)이 경과한 경우 쿼리를 강제로 다시 가져올 수 있습니다(a number가 제공된 경우). 기본값:false
  // refetchOnFocus - 브라우저 창이 다시 포커스를 받을 때 쿼리를 강제로 다시 가져올 수 있습니다. 기본값:false
  // refetchOnReconnect - 네트워크 연결을 다시 얻을 때 쿼리를 강제로 다시 가져올 수 있습니다. 기본값:false
  refetchOnMountOrArgChange: true, // 지정시간 초과시 다시 가져오기
  tagTypes: ["Post"],
  endpoints: (builder) => ({
    // 본사용 API (as 카운트 )
    asCount: builder.query({
      query: (brand?: string) => ({
        url: brand ? `as/count?brand=${brand}` : "as/count",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      extraOptions: { maxRetries: 3 },
    }),
    // 하루치 as 쿼리
    asOneDayList: builder.query({
      query: (brand?: string) => ({
        url: brand ? `as/vmd/as?brand=${brand}` : "as/vmd/as",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        // body: data,
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 견적서  쿼리
    estimateList: builder.query({
      query: (brand?: string) => ({
        url: brand ? `/as/vmd/estimate?brand=${brand}` : "/as/vmd/estimate",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        // body: data,
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 완료보고  쿼리
    completeList: builder.query({
      query: (brand?: string) => ({
        url: brand ? `/as/vmd/complete?brand=${brand}` : "/as/vmd/complete",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        // body: data,
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 매장용 API (as 진행중인 쿼리)
    asProgressList: builder.query({
      query: (id: string) => ({
        url: `as/store`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 업체용 API as 진행해야하는 쿼리
    asMustList: builder.query({
      query: (id: string) => ({
        url: `/as/company/estimate`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 업체용 API as 방문예정 쿼리
    asHopeList: builder.query({
      query: (id: string) => ({
        url: `/as/company/visit`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 홈 공지 리스트
    noticeList: builder.query({
      query: () => ({
        url: `notice/home`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        // body: data,
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useAsCountQuery,
  useAsOneDayListQuery,
  useEstimateListQuery,
  useCompleteListQuery,
  useAsProgressListQuery,
  useAsMustListQuery,
  useAsHopeListQuery,
  useNoticeListQuery,
} = homeAPI;
